import StoredLayout from '../../layouts/StoredLayout'
import SimpleLineIcons from './SimpleLineIcons'
export default StoredLayout(SimpleLineIcons)
